import type { UseMutationResult } from '@tanstack/react-query';
import { useBffPostMutation } from '../bff';
import { BffQueryKey } from '../model/BffQueryKey';
import type { CreateAnswerTypes } from './model';

export const useSubmitAnswer = (
    questionId: number,
): UseMutationResult<CreateAnswerTypes, unknown, CreateAnswerTypes> =>
    useBffPostMutation<CreateAnswerTypes, CreateAnswerTypes>(
        `/turn-to/answers/${questionId}`,
        [],
        [BffQueryKey.TURN_TO_DATA],
    );
